import { useTranslation } from 'react-i18next';
import { Checkbox } from 'antd';
import { useRegisterValues } from '../../../../providers/RegisterProvider';
import { AttentionHint } from 'components/UI/AttentionHint';
import { Form, FormItem } from 'components/UI/Form';
import { Input } from 'components/UI/Input';
import * as Styled from './styles';
import * as StyledShared from '../../styles';
import { Pattern } from 'constants/validation';

export const RegisterCreatorStepThree = () => {
  const { form } = useRegisterValues();

  const { t } = useTranslation();

  return (
    <Styled.RegisterCreatorStepThreeWrapper>
      <Form layout="vertical" form={form} name="registerCreator">
        <FormItem
          name="bank_account_number"
          label={t('account.bankAccountNumber')}
          rules={[
            {
              pattern: Pattern.number,
              message: t('account.pleaseEnterOnlyNumber')
            },
            {
              required: true,
              message: t('account.requiredBankAccountNumber')
            }
          ]}
        >
          <Input />
        </FormItem>
        <FormItem
          name="bank_agreement"
          initialValue={false}
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) => {
                if (!value) {
                  return Promise.reject();
                }
                return Promise.resolve();
              }
            }
          ]}
        >
          <Checkbox>
            <StyledShared.Label $required>
              {t('account.bankAgreement')}
            </StyledShared.Label>
          </Checkbox>
        </FormItem>
      </Form>
      <AttentionHint
        text={t('account.attentionBankAccountNumberHint')}
        subText={t('account.bankCardHint')}
      />
    </Styled.RegisterCreatorStepThreeWrapper>
  );
};
